export const RULE_VALIDATE = {
    name: [
        { required: true, message: '配置名称必填', trigger: 'blur' }
    ],
    content: [
      
        {
             validator(rule, value, callback) {
            if (value && value.length > 0) {
                callback();
            } else {
                callback(new Error('人员列表必选'));
            }
          },    
          required: true
        },
    ],
}


export const KEY_NAME = 'legal_personnel_config'
export const CONTRACT_MANAGER_CONFIG = 'contract_manager_config'
export const DEFAULT_DATA = {
    name:'',
    key_name:'',
    content: [],
    id: 0
}